
import { h } from "preact";

import IconProps from "../../Icons/IconProps";

const DEFAULT_COLOR = "var(--marker-blue)";
const DEFAULT_WIDTH = 18;

function IconAIThickStar({
    class: cssClass,
    color,
    width = DEFAULT_WIDTH
}: IconProps) {
    const stroke = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width={width} height={width} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" stroke={stroke} d="M15.613 7.729zm0 0zM7.794 1.79c.462-1.054 1.954-1.054 2.417 0v.002l1.44 3.297h-.002c.248.566.7 1.017 1.265 1.264l3.27 1.43.03.01.095.046c.953.51.92 1.921-.099 2.369l-.002.001-3.295 1.44a2.453 2.453 0 0 0-1.264 1.262l.001.001-1.436 3.293c-.45 1.038-1.875 1.047-2.375.092l-.045-.096L6.4 12.968a2.453 2.453 0 0 0-1.256-1.27l-3.356-1.485-.096-.046c-.958-.51-.92-1.928.099-2.372l3.3-1.44.206-.103c.468-.26.841-.668 1.057-1.163l1.438-3.296v-.002zm9.005 7.05a.989.989 0 0 1 0 .006V8.84zM2.596 8.384l.01.004-.012-.006.002.002z" stroke-width="2"/>
        </svg>
    );
}

export default IconAIThickStar;
